<template>
  <!-- Personal Info Modal -->
  <v-dialog v-model="modalDialog" max-width="725px">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Personal Information</h5>
        <button type="button" class="close" @click="method(employee)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="putPersonalInfo">
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="alert alert-success alert-dismissible fade show"
                role="alert"
                v-if="message"
              >
                <strong>Success!</strong> {{ message }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Passport No</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="passportIdentificationNumber"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Passport Exp Date.</label>
                <div class="cal-icon">
                  <datepicker
                    v-model="passportExpiryDate"
                    bootstrap-styling
                    class="datetimepicker"
                    type="text"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>National Identityddd No</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="nationalIdentityNumber"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Tel</label>
                <input
                  class="form-control"
                  type="text"
                  v-model.trim="$v.phone.$model"
                  :class="{ 'is-invalid': submitted && $v.phone.$error }"
                />
              </div>
              <div
                v-if="submitted && !$v.phone.required"
                class="invalid-feedback"
              >
                Phone is required
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Nationality <span class="text-danger">*</span></label>
                <input
                  class="form-control"
                  type="text"
                  v-model.trim="$v.nationality.$model"
                />
              </div>
              <div
                v-if="submitted && !$v.nationality.required"
                class="invalid-feedback"
              >
                Nationality is required
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Religion</label>
                <input
                  class="form-control"
                  type="text"
                  v-model.trim="$v.religion.$model"
                />
              </div>
              <div
                v-if="submitted && !$v.religion.required"
                class="invalid-feedback"
              >
                Religion is required
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Marital status <span class="text-danger">*</span></label>
                <select
                  class="select form-control"
                  v-model.trim="$v.maritalStatus.$model"
                >
                  <option>-</option>
                  <option>Single</option>
                  <option>Married</option>
                </select>
              </div>
              <div
                v-if="submitted && !$v.maritalStatus.required"
                class="invalid-feedback"
              >
                Marital Status is required
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label
                  >Employment of spouse
                  <span class="text-danger">*</span></label
                >
                <select
                  class="select form-control"
                  v-model="employmentOfSpouse"
                >
                  <option>-</option>
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label
                  >No. of children <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="noOfChildren"
                />
              </div>
            </div>
          </div>
          <div class="submit-section">
            <button class="btn btn-primary submit-btn" type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </v-dialog>
  <!-- /Personal Info Modal -->
</template>

<script>
import { required, numeric, sameAs } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import { workerService } from "@/services/workerService";
export default {
  components: {
    Datepicker
  },
  props: {
    model: {},
    dialog: Boolean,
    method: { type: Function }
  },
  data() {
    return {
      modalDialog: this.dialog,
      employee: this.model,
      passportIdentificationNumber: this.model.passportIdentificationNumber,
      nationality: this.model.nationality,
      phone: this.model.phone,
      religion: this.model.religion,
      maritalStatus: this.model.maritalStatus,
      nationalIdentityNumber: this.model.nationalIdentityNumber,
      passportExpiryDate: new Date(
        this.model.passportExpiryDate
      ).toLocaleDateString(),
      noOfChildren: this.model.noOfChildren,
      employmentOfSpouse: this.model.employmentOfSpouse,
      message: "",
      error: "",
      submitted: false
    };
  },

  validations: {
    phone: { required },
    nationality: { required },
    religion: { required },
    maritalStatus: { required }
  },
  mounted() {
    // console.log(this.model);
    this.$emit("update:employee", this.employee);
    this.$emit("update:personalInfoDialog", this.dialog);
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
  },
  methods: {
    putPersonalInfo() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.model.passportIdentificationNumber = this.passportIdentificationNumber;
      (this.model.nationality = this.nationality),
        (this.model.phone = this.phone),
        (this.model.religion = this.religion),
        (this.model.maritalStatus = this.maritalStatus),
        (this.model.nationalIdentityNumber = this.nationalIdentityNumber),
        (this.model.passportExpiryDate = this.passportExpiryDate),
        (this.model.employmentOfSpouse = this.employmentOfSpouse),
        (this.model.noOfChildren = this.noOfChildren);
      workerService
        .updateCasualWorkerPersonalInfo(this.model.id, this.model)
        .then(d => {
          this.message = "Personal Info update successfully!";
          workerService.GetCasualWorkerDetail(this.model.id).then(
            model => {
              this.employee = model;
              if (!this.employee.casualWorkerStatutory) {
                this.employee.casualWorkerStatutory = {
                  id: 0,
                  salaryBasis: "",
                  salaryAmount: 0.0
                };
              }
              if (!this.employee.casualWorkerTax) {
                this.employee.casualWorkerTax = {
                  id: 0,
                  tin: "",
                  taxCode: "",
                  taxOffice: "",
                  tax: {}
                };
              } else {
                this.employee.casualWorkerTax.tax = {
                  taxOffice: this.employee.casualWorkerTax.taxCode,
                  description: this.employee.casualWorkerTax.taxOffice
                };
              }
              this.method(this.employee);
            },
            error => {
              this.error = error;
            }
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/casualworker/CPersonalInfoModal.vue